export interface WranglesXLRuntimeConfig {
  wranglesAgentApiUrl?: string
  notesApiUrl?: string
}

declare global {
  interface Window {
    __WRANGLES_XL_CONFIG__?: WranglesXLRuntimeConfig
  }
}

/** Override only notes; other shared-client routes keep their existing targets. */
export const getNotesRoutes = (): { generateNotes: string } => {
  const configured =
    typeof window === 'undefined'
      ? undefined
      : window.__WRANGLES_XL_CONFIG__?.notesApiUrl
  const endpoint =
    typeof configured === 'string' ? configured.trim().replace(/\/+$/, '') : ''
  if (
    !endpoint ||
    !/^https:\/\/[A-Za-z0-9.-]+(:[0-9]+)?\/[A-Za-z0-9._~%/-]+$/.test(endpoint)
  ) {
    throw new Error('Notes API endpoint configuration is missing or invalid.')
  }
  const url = new URL(endpoint)
  if (!url.pathname.endsWith('/notes')) {
    throw new Error('Notes API endpoint must end with /notes.')
  }
  return { generateNotes: endpoint }
}
